import React from "react"
import CreatableSelect from "react-select/creatable"

import "./style.scss"

const CreatableDropDown = (props) => {
  return (
    <CreatableSelect
      placeholder={props.placeholder}
      isClearable
      onChange={props.onChange}
      onCreateOption={props.onCreateOption}
      options={props.options}
      value={{ value: props.value, label: props.label }}
      className={props.style}
      classNamePrefix="react-select"
    />
  )
}

export default CreatableDropDown
